import React from "react";
import { NavLink } from "react-router-dom";
import "./AdminLayout.css";

type NavItem = { to: string; label: string; icon: string; end?: boolean };

const groups: { label: string; links: NavItem[] }[] = [
  {
    label: "Overview",
    links: [
      {
        to: "/admin",
        label: "Dashboard",
        icon: "bi bi-grid-1x2-fill",
        end: true,
      },
      {
        to: "/admin/cost-estimator",
        label: "Cost Estimator",
        icon: "bi bi-calculator-fill",
      },
    ],
  },
  {
    label: "Management",
    links: [
      { to: "/admin/requests",      label: "Requests",     icon: "bi bi-inboxes-fill" },
      { to: "/admin/notifications", label: "Send Notify",  icon: "bi bi-send-fill"   },
      { to: "/admin/projects", label: "Projects", icon: "bi bi-kanban-fill" },
      // { to: "/admin/projects/new", label: "Add Project", icon: "bi bi-plus-square-fill" },
      {
        to: "/admin/projects/progress",
        label: "Task Progress",
        icon: "bi bi-list-check",
      },
      {
        to: "/admin/projects/progress-analytics",
        label: "Progress Charts",
        icon: "bi bi-bar-chart-line-fill",
      },
      { to: "/admin/page-images", label: "Page Images", icon: "bi bi-images" },
      // {
      //   to: "/admin/project-images",
      //   label: "Project Images",
      //   icon: "bi bi-images",
      // },
    ],
  },
  {
    label: "People",
    links: [
      { to: "/admin/employees", label: "Employees", icon: "bi bi-people-fill" },
      // { to: "/admin/employees/new", label: "Add Employee", icon: "bi bi-person-plus-fill" },
      { to: "/admin/clients", label: "Clients", icon: "bi bi-people-fill" },
      { to: "/admin/expenses", label: "Expenses", icon: "bi bi-wallet2" },
      { to: "/admin/payments", label: "Payments", icon: "bi bi-cash-coin" },

      {
        to: "/admin/reviews",
        label: "Reviews",
        icon: "bi bi-chat-square-quote-fill",
      },
    ],
  },
  {
    label: "Account",
    links: [
      { to: "/admin/contact-settings", label: "Site Settings", icon: "bi bi-gear-fill" },
      { to: "/admin/profile",          label: "Profile",       icon: "bi bi-person-circle" },
      {
        to: "/admin/manage-passwords",
        label: "Manage Passwords",
        icon: "bi bi-shield-lock-fill",
      },
    ],
  },
];

const Sidebar: React.FC<{ isOpen: boolean; onClose: () => void }> = ({
  isOpen,
  onClose,
}) => {
  return (
    <aside className={`admin-sidebar${isOpen ? " admin-sidebar--open" : ""}`}>
      <div className='d-flex align-items-center justify-content-between mb-3'>
        <NavLink
          to='/admin'
          className='admin-brand'
          style={{ flex: 1, marginBottom: 0 }}
          onClick={onClose}
        >
          <span className='admin-brand-mark'>D24</span>
          <span>
            <strong>Dialin24</strong>
            <small>Admin Panel</small>
          </span>
        </NavLink>
        <button
          type='button'
          className='admin-sidebar-close'
          aria-label='Close menu'
          onClick={onClose}
        >
          <i className='bi bi-x-lg'></i>
        </button>
      </div>

      <nav className='admin-nav'>
        {groups.map((group) => (
          <div key={group.label} className='admin-nav-group'>
            <p className='admin-nav-group-label'>{group.label}</p>
            {group.links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end ?? false}
                className={({ isActive }) =>
                  `admin-nav-link${isActive ? " active" : ""}`
                }
                onClick={onClose}
              >
                <i className={link.icon}></i>
                <span>{link.label}</span>
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
